export default "__VITE_ASSET__76fc7942__"